/* eslint-disable arrow-body-style */
import React from 'react'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import Image from 'next/image'
import { CHALLAN_INFO_TITLE } from './constants'
import styles from './infoHighlightGrid.module.scss'

const InfoHighlightGrid = ({ data }) => {
  const { data: productPageContent, isSemPage } = data

  const infoSectionData = productPageContent?.attributes

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.infoHighlightGridRootContainer} ${!isSemPage ? styles.seoStyles : ''} white`}>
        <p className={styles.infoHighlightTitle}>{infoSectionData?.title || CHALLAN_INFO_TITLE}</p>
        <p className={styles.infoHighlightTitle}>{infoSectionData?.subtitle}</p>

        <div className={styles.keyHightlightItems}>
          {infoSectionData?.contentKeyItems?.map(keyItem => {
            const { id, contentLabel, contentImage } = keyItem
            const imageUrl = contentImage?.data?.attributes?.url

            return (
              <div key={id} className={styles.keyItemContainer}>
                <Image src={imageUrl} alt={contentLabel} width={24} height={24} className={styles.keyItemImage} />
                <p className={styles.keyItemLabel}>{contentLabel}</p>
              </div>
            )
          })}
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default InfoHighlightGrid
